export default {

  methods: {
    /**
     * Set the aria-hidden value on a DOM element.
     * 
     * @param {*} element DOM element.
     */
    setAriaHidden(element, value = false) {
      element.setAttribute('aria-hidden', value);
    }
  }

}